export function getTeamIdFromUrl(urlString = window.location.href) {
  const url = new URL(urlString);

  return url.pathname.split('/')[2];
}

export function getPageNameFromUrl(urlString = window.location.href) {
  const url = new URL(urlString);

  return url.hash ? url.hash.split('/')[1] : url.pathname.split('/')[1];
}

export function isPageMultiTeamSupported() {
  return false;
}
